
    <button *ngIf="dismissible" type="button" class="close" aria-label="Close" i18n-aria-label="@@ngb.alert.close"
      (click)="closeHandler()">
      <span aria-hidden="true">&times;</span>
    </button>
    <ng-content></ng-content>
    


// WEBPACK FOOTER //
// ./node_modules/@ng-bootstrap/ng-bootstrap/ng-bootstrap.d.ts.NgbAlert.html